import './culture-selector.scss';
import mountCultureSelector from './mountCultureSelector';

mountCultureSelector()